<template>
  <div>
    <div>
      <!-- 时间选择 -->
      <el-form :inline="true" class="form">
        <el-form-item :label='$t("time.timeQuery")'>
          <el-date-picker 
            style="width:370px"
            :size="size"
            v-model="timeRange" 
            :picker-options="pickerOptions"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            value-format="yyyy-MM-dd HH-mm-ss"
            :range-separator='$t("time.to")'
            :start-placeholder='$t("time.startDate")'
            :end-placeholder='$t("time.endDate")'
          ></el-date-picker>
        </el-form-item>
        <!-- 查询 -->
        <el-form-item>
          <el-button 
            type="primary" 
            plain 
            :size="size"
            style="margin-left:8px;"
            @click="handleQuery"
          >{{ $t("public.query")}}</el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item>
          <el-button 
            :size="size"
            type="primary" 
            style="margin-left:10px"
            @click="download"
          >{{ $t("public.download")}}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      timeRange:[],
      pickerOptions:{
        disabledDate(date) {
          return date > new Date(new Date().getTime())
        }
      }
    }
  },
  computed:{
    size() {
      return this.$store.getters.size
    },
  },
  methods:{
    handleQuery(){
      this.$emit("handleQuery",this.timeRange);
    },
    download(){
      this.$emit("download",this.timeRange);
    }
  },
  mounted(){
    let now = new Date();
    this.timeRange = [new Date(now.getFullYear(),now.getMonth(),now.getDate()-1),new Date(new Date(now.getFullYear(),now.getMonth(),now.getDate()).getTime()-1)]
    // console.log(this.timeRange);
    this.$nextTick(()=>{
      this.handleQuery();
    });
  }
}
</script>
<style lang="scss" scoped>
.form {
  ::v-deep .el-form-item {
      margin-bottom: 0px !important;
  }
}
</style>